import { Directive, Input, TemplateRef } from '@angular/core';

import type { SelectedItemContext } from './types';
import type { Select2Item } from '../../types';

@Directive({
  standalone: true,
  selector: '[rtSelectSelectedItem]',
  exportAs: 'selectedItemDir',
})
export class Select2SelectedItemDirective<Select extends { items: Select2Item[] } | null> {
  public static ngTemplateContextGuard<Select extends { items: Select2Item[] } | null>(
    dir: Select2SelectedItemDirective<Select>,
    ctx: unknown,
  ): ctx is SelectedItemContext<Select> {
    return true;
  }
  @Input() public rtSelectSelectedItem: Select;

  constructor(public templateRef: TemplateRef<SelectedItemContext<Select>>) {}
}
